import { render, staticRenderFns } from "./Regulares.vue?vue&type=template&id=edff5a88"
import script from "./Regulares.vue?vue&type=script&lang=js"
export * from "./Regulares.vue?vue&type=script&lang=js"
import style0 from "./Regulares.vue?vue&type=style&index=0&id=edff5a88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VTextField})
